import { IServerAddresses } from 'src/sync';
import { BaseApiOutput } from './base-api.model';
import { FileItem } from '../files.model';
import { Region } from '../enums';

export class LinkPathListApiOutput extends BaseApiOutput {
  public oid: number; // owner id
  public is_pro: 1 | 0;
  public is_business: 1 | 0;
  public share_id: number;
  public sync_id: string;
  public root_sync_id: string;
  public compat: 1 | 0;
  public previewonly: 1 | 0;
  public file_edit: 1 | 0;
  public upload: 0 | 1 | 2;
  public linkversion: number;
  public iterations: number;
  public salt: string;
  public pathitems: FileItem[];
  public servers: IServerAddresses;
  public servers_web: string[];
  public servers_preview: string[];
  public servers_compat: string[];
  public cwd: FileItem;
  //whitelabel attributes
  public image_cachekey: string;
  public header_primary_color: string;
  public header_text_color: string;
  public button_primary_color: string;
  public button_text_color: string;
  public link_text_color: string;
  public url?: string;
  public url_dl?: string;
  //comment feature
  public allow_comment: 0 | 1 | 2;
  public enc_comment_key: string;
  public comment_notification: 0 | 1;
  //owner info
  public id: number;
  public team_id: number;
  public is_multi_admin: boolean;
  public is_on_trial: boolean;
  public odc: Region;
  public owner_device_id: number;
  public osb?: string;
}

export class LinkPathListApiInput {
  public sync_id: number;
  public publink_id: string;
  public passwordlock?: string;
  public key: string;
}
